// extracted by mini-css-extract-plugin
module.exports = {"layout":"Accordion_layout__2Dy5t"};